var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUnitedStates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2695C24.8366 32.2695 32 25.1061 32 16.2695C32 7.43297 24.8366 0.269531 16 0.269531C7.16344 0.269531 0 7.43297 0 16.2695C0 25.1061 7.16344 32.2695 16 32.2695Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3037 16.2696H31.9993C31.9993 14.8255 31.8068 13.4265 31.4481 12.0957H15.3037V16.2696Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3037 7.92198H29.651C28.6715 6.32373 27.4192 4.91105 25.9591 3.74805H15.3037V7.92198Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 32.2698C19.7652 32.2698 23.2262 30.9683 25.9594 28.7915H6.03986C8.77298 30.9683 12.234 32.2698 15.9996 32.2698Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34797 24.6178H29.6512C30.4375 23.3347 31.0473 21.9322 31.4484 20.4438H0.550781C0.951844 21.9322 1.56166 23.3347 2.34797 24.6178Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4115 2.76816H8.86956L7.51331 3.75347L8.03137 5.34778L6.67519 4.36247L5.319 5.34778L5.7665 3.97047C4.57237 4.96516 3.52575 6.13053 2.66325 7.42903H3.13044L2.26712 8.05622C2.13262 8.28059 2.00362 8.50853 1.88 8.73984L2.29225 10.0087L1.52313 9.44984C1.33194 9.85491 1.15706 10.2691 0.999875 10.6919L1.45406 12.0899H3.13044L1.77419 13.0752L2.29225 14.6695L0.936063 13.6842L0.123687 14.2745C0.042375 14.9281 0 15.5938 0 16.2695H16C16 7.43303 16 6.39128 16 0.269531C12.8393 0.269531 9.89281 1.18641 7.4115 2.76816ZM8.03137 14.6695L6.67519 13.6842L5.319 14.6695L5.83706 13.0752L4.48081 12.0899H6.15719L6.67519 10.4956L7.19319 12.0899H8.86956L7.51331 13.0752L8.03137 14.6695ZM7.51331 8.41434L8.03137 10.0087L6.67519 9.02334L5.319 10.0087L5.83706 8.41434L4.48081 7.42903H6.15719L6.67519 5.83472L7.19319 7.42903H8.86956L7.51331 8.41434ZM13.7705 14.6695L12.4143 13.6842L11.0581 14.6695L11.5762 13.0752L10.2199 12.0899H11.8963L12.4143 10.4956L12.9323 12.0899H14.6087L13.2524 13.0752L13.7705 14.6695ZM13.2524 8.41434L13.7705 10.0087L12.4143 9.02334L11.0581 10.0087L11.5762 8.41434L10.2199 7.42903H11.8963L12.4143 5.83472L12.9323 7.42903H14.6087L13.2524 8.41434ZM13.2524 3.75347L13.7705 5.34778L12.4143 4.36247L11.0581 5.34778L11.5762 3.75347L10.2199 2.76816H11.8963L12.4143 1.17384L12.9323 2.76816H14.6087L13.2524 3.75347Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.269531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUnitedStates);
export default __webpack_public_path__ + "static/media/flag_united_states.96fedf7ca963f3a04d398ae92a3d160b.svg";
export { ForwardRef as ReactComponent };